<template>
  <div class="container">
    <LocationSettings />
    <hr />
    <SchedulerSettings />
    <hr />
    <MemberManagement />
    <hr />
    <DeviceManagement />
  </div>
</template>

<script>
import LocationSettings from "./location-settings"
import MemberManagement from "./member-management"
import SchedulerSettings from "./scheduler-settings"
import DeviceManagement from "./device-management"
import { state } from "@/store"

export default {
  name: "project-settings",
  components: {
    LocationSettings,
    MemberManagement,
    DeviceManagement,
    SchedulerSettings
  },
  watch: {
    violatesAdmin: {
      immediate: true,
      handler() {
        if (this.violatesAdmin) {
          this.$router.push("/")
        }
      }
    }
  },
  computed: {
    violatesAdmin() {
      return state.userRole && !state.isAdmin
    }
  }
}
</script>
